import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommentBasicModel} from '@core/modules/rest/consent/response/comment-basic.model';
import {DropdownModel} from '@shared/components/dropdown-button/model/dropdown.model';
import {TranslateService} from '@ngx-translate/core';
import {ButtonActionsEnum} from '@shared/components/dropdown-button/enum/button-actions.enum';
import {TtsHelperService} from '@shared/utils/tts-helper.service';

@Component({
    selector: 'app-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {
    @Input() sideMenuOpen: boolean;
    @Input() comment: CommentBasicModel | undefined;
    @Input() disabled = false;
    @Input() active = false;
    @Input() showCommentActions = true;
    @Input() showEntireComment = true;
    @Input() markComment = false;
    @Input() cssClasses: string;
    @Output() editEvent: EventEmitter<string> = new EventEmitter<string>();
    @Output() deleteEvent: EventEmitter<string> = new EventEmitter<string>();

    menuItems: DropdownModel[];
    triggerData: [{ triggerBtnIcon: string; triggerBtnClasses: string; triggerBtnIconSize: string; triggerBtnAriaLabel: any; triggerBtnIconColor: string }];

    constructor(private translateService: TranslateService, private ttsHelperService: TtsHelperService) {
    }

    ngOnInit(): void {
        this.triggerData = [{
            triggerBtnClasses: 'icon',
            triggerBtnIcon: 'more_horiz',
            triggerBtnIconColor: 'gray-07',
            triggerBtnIconSize: '52',
            triggerBtnAriaLabel: this.translateService.instant('SCREEN_READER.MENU_HELP')
        }];
        this.menuItems = [
            {
                key: ButtonActionsEnum.Edit,
                btnCssClasses: 'small outlined dropdown-item',
                btnIcon: 'edit',
                btnIconSize: '20',
                btnIconColor: '',
                btnLabelColor: '',
                btnLabel: this.translateService.instant('GENERAL.EDIT'),
                btnAriaLabel: this.translateService.instant('GENERAL.EDIT'),
                disabled: false
            },
            {
                key: ButtonActionsEnum.Delete,
                btnCssClasses: 'small outlined',
                btnIcon: 'delete',
                btnIconSize: '20',
                btnIconColor: 'red-07',
                btnLabelColor: 'red-07',
                btnLabel: this.translateService.instant('GENERAL.DELETE'),
                btnAriaLabel: this.translateService.instant('GENERAL.DELETE') + this.translateService.instant('GENERAL.BUTTON'),
                disabled: false
            }
        ];
    }

    buttonActions(event): void {
        if (event === ButtonActionsEnum.Edit) {
            this.editEvent.emit(this.comment.id);
        } else {
            this.deleteEvent.emit(this.comment.id);
        }
    }

    stripHTMLTags(informationUnitTitle: string): string {
        return this.ttsHelperService.removeHTMLTags(informationUnitTitle);
    }
}
